import PropTypes from "prop-types";
import { memo, useState, useCallback } from "react";
import NavList from "./navList";

// Tailwind Subheader (instead of MUI styled)
const StyledSubheader = ({ onClick, children }) => (
    <div
        onClick={onClick}
        className="
      text-[18px] cursor-pointer flex items-center justify-start w-full
      px-5 py-2 mb-1 rounded-lg
      text-white bg-red-700
      transition-colors duration-200
      hover:bg-red-900
    "
    >
        {children}
    </div>
);

const navVerticalConfig = () => ({
    itemGap: 1,
    iconSize: 24,
    currentRole: "admin",
    itemRootHeight: 44,
    itemSubHeight: 36,
    itemPadding: "px-2 py-1", // tailwind version
    itemRadius: 8,
    hiddenLabel: false,
});

function NavSection({ data, config, currentPath, className = "", ...other }) {
    return (
        <div className={`flex flex-col ${className}`} {...other}>
            {data?.map((group, index) => (
                <Group
                    key={group.subheader || index}
                    subheader={group.subheader}
                    items={group.items}
                    config={navVerticalConfig()}
                    currentPath={currentPath}
                />
            ))}
        </div>
    );
}

NavSection.propTypes = {
    config: PropTypes.object,
    data: PropTypes.array,
    className: PropTypes.string,
};

export default memo(NavSection);

// ----------------------------------------------------------------------

function Group({ subheader, items, config, currentPath }) {
    const [open, setOpen] = useState(true);

    const handleToggle = useCallback(() => {
        setOpen((prev) => !prev);
    }, []);

    const renderContent = items?.map((list) => (
        <NavList
            key={list.title + list.path}
            data={list}
            depth={1}
            hasChild={!!list.children}
            config={config}
        />
    ));

    return (
        <div className="px-2 mb-3">
            {subheader ? (
                <>
                    <StyledSubheader onClick={handleToggle}>
                        {subheader}
                    </StyledSubheader>

                    {/* Collapse equivalent */}
                    <div
                        className={`transition-all duration-300 ${
                            open
                                ? "opacity-100 overflow-visible max-h-none"
                                : "max-h-0 opacity-0 overflow-hidden"
                        } mt-1`}
                    >
                        {renderContent}
                    </div>
                </>
            ) : (
                renderContent
            )}
        </div>
    );
}

Group.propTypes = {
    config: PropTypes.object,
    items: PropTypes.array,
    subheader: PropTypes.string,
};
